module["exports"] = [
  "g.",
  "gđa.",
  "gđa.",
  "gđa",
  "dr."
];
